<template>
  <div class="error">
    <span>Sorry,网站开了点小差！！</span>
  </div>
</template>

<script>

import { reportLoad } from '@/report/index.js'

export default {
  name: 'Index',

  mounted () {
    reportLoad({ page: 2, pagetype: 0 })
    console.error('报错了', this.is404)
  }
}
</script>

<style scoped lang="scss">
  .error { height: 600px; padding-top: 100px; font-size: 20px; text-align: center; }
</style>
